module.exports = __webpack_public_path__ + "img/en-gb.39f68f6b.png";